module.exports = __webpack_public_path__ + "static/Benjamin_Haibe-Kains_headshot_lores-f60759966ea220ccffa8a3b37e2821cf.png";